export const DEEPER_TEAM_ANALYSIS_EXPERIENCE_KEY = 'deeperTeamAnalysisExperienceSeen'
export const DEEPER_INDIVIDUAL_ANALYSIS_EXPERIENCE_KEY = 'deeperIndividualAnalysisExperienceSeen'
